// Intellectual Passion Template - Common App Prompt #6
export const intellectualPassionTemplate = {
  id: 'intellectualPassion',
  title: 'Intellectual Passion',
  description: 'For topics, ideas, or concepts so engaging that they make you lose track of time - showcasing deep intellectual curiosity',
  sections: [
    {
      id: 'the_rabbit_hole_moment',
      label: 'The Rabbit Hole Moment',
      type: 'opening',
      prompt: 'Take me to a specific time when you fell so deep into this topic that you lost all awareness of time or surroundings.',
      coachVoice: "I want to feel your brain getting hijacked by fascination. Show me the moment when curiosity took over completely.",
      sample: "I was supposed to write a two-page report on fractals for math class, but six hours later I was still at my computer, zooming deeper into the Mandelbrot set, watching infinite complexity emerge from a simple equation. My mom found me at 2 AM, surrounded by printed images and scribbled calculations, completely unaware I'd missed dinner.",
      minWords: 80,
      unlockWords: 40
    },
    {
      id: 'what_hooks_your_mind',
      label: 'What Hooks Your Mind',
      type: 'stakes',
      prompt: 'What is it about this topic that creates such mental magnetism for YOU specifically?',
      coachVoice: "Don't just say it's interesting. What specific aspect grabs YOUR brain in a way that creates genuine intellectual obsession?",
      sample: "It's the paradox of infinite complexity hiding inside apparent simplicity. A formula that looks boring on paper generates art more intricate than anything humans consciously design. It makes me question what other seemingly simple things contain hidden universes - from ant colonies to neural networks to market behaviors.",
      minWords: 80,
      unlockWords: 40
    },
    {
      id: 'how_you_feed_the_obsession',
      label: 'How You Feed the Obsession',
      type: 'approach',
      prompt: 'Show me the specific ways you pursue deeper understanding when this fascination strikes.',
      coachVoice: "What does YOUR learning process look like when you're genuinely obsessed? How do you chase down understanding?",
      sample: "I create what I call 'knowledge webs' - starting with one concept and following every connection until I've filled entire poster boards with linked ideas, equations, and questions. For fractals, this led me through chaos theory, computer graphics, biology (coastline patterns), economics (market volatility), and even music composition (recursive melodies).",
      minWords: 100,
      unlockWords: 50
    },
    {
      id: 'how_passion_shapes_your_lens',
      label: 'How Passion Shapes Your Lens',
      type: 'growth',
      prompt: 'How does this deep fascination change the way you see other subjects, problems, or aspects of life?',
      coachVoice: "I want to see how this intellectual passion has become a lens through which you view everything else. Give me specific examples.",
      sample: "I now see patterns everywhere that others miss. When our school's budget crisis hit, I instinctively started looking for the underlying feedback loops causing the problem, not just the surface symptoms. My friends think I'm weird for getting excited about the mathematical beauty in urban planning or viral spread, but these aren't separate subjects to me - they're all expressions of the same underlying patterns.",
      minWords: 80
    }
  ]
};